export default __webpack_public_path__ + "static/media/info.23b11c04.png";